import React from 'react';
import { useAppSelector } from '../app/hooks';

export const Loader = () => {
    const calendarLoadingLabel = useAppSelector(state => state.settings.calendarLoadingLabel);
    return (
        <div className="ace-cal-loading">
            <p className="visually-hidden">
                {calendarLoadingLabel}
            </p>
            <div className="ace-cal-loader-container" role="presentation">
                <div className="ace-cal-loader"></div>
            </div>
        </div>
    )
}